import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

const useRedirect = (isRedirect: boolean): void => {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (isRedirect && pathname !== '/quanta') {
      router.replace('/quanta', { scroll: false });
    }
  }, [isRedirect, router, pathname]);
};

export default useRedirect;
